import {
  TranslationConcretingMessages,
  ConcretingMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingMessages = {
  [ConcretingMessages.todayText]: "Este Dia",
  [ConcretingMessages.pastText]: "Anteriores",
  [ConcretingMessages.futureText]: "Futuras",
  [ConcretingMessages.trackDelivery]: "¡Seguimiento de la entrega!"
};
